// AppFooter.jsx
import React from "react";
import { NavLink } from "react-router-dom";
import { ROUTES } from "../../constants/navigation";
import TorumPayLogo from "../../assets/svg/torum-pay-logo.svg";
import "./AppFooter.scss";

import "../../styles/variables.scss";

const COMING_SOON = new Set(["HELPCENTER", "LEARN"]);

function FooterItem({ routeKey }) {
  const route = ROUTES[routeKey];
  const isComingSoon = COMING_SOON.has(routeKey);

  // When "coming soon", render a non-clickable span that swaps text on hover
  if (isComingSoon) {
    return (
      <span
        className="nav-link coming-soon"
        role="link"
        aria-disabled="true"
        onClick={(e) => e.preventDefault()}
      >
        <span className="label">{route.label}</span>
        <span className="label-hover">Coming Soon</span>
      </span>
    );
  }

  // Normal link (supports external target if present)
  return route.target === "_blank" ? (
    <a
      className="nav-link"
      href={route.path}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="label">{route.label}</span>
    </a>
  ) : (
    <NavLink className="nav-link" to={route.path}>
      <span className="label">{route.label}</span>
    </NavLink>
  );
}

function AppFooter() {
  return (
    <div className="tp-main-app-footer">
      <div className="tp-main-app-footer-wrapper">
        <div className="app-footer-top">
          <img
            className="torum-pay-logo"
            src={TorumPayLogo}
            alt="torum-pay-logo"
          />

          <div className="app-footer-sub-links-wrapper">
            <div className="app-footer-sub-links">
              <div className="footer-title Fu-26s-26l fw500">DISCOVER</div>
              {Object.keys(ROUTES)
                .slice(0, 3) // HELPCENTER, LEARN, FEES
                .map((key) => (
                  <div key={key} className="sub-links Ft-16s-16l">
                    <FooterItem routeKey={key} />
                  </div>
                ))}
            </div>

            <div className="app-footer-sub-links">
              <div className="footer-title Fu-26s-26l fw500">LEGAL</div>
              {Object.keys(ROUTES)
                .slice(3, 5)
                .map((key) => (
                  <div key={key} className="sub-links Ft-16s-16l">
                    <FooterItem routeKey={key} />
                  </div>
                ))}
            </div>

            <div className="app-footer-sub-links">
              <div className="footer-title Fu-26s-26l fw500 ">LOCATE US</div>
              <div className="Ft-16s-24l">
                A-19-8, Tower A, Vertical Business Suite, Jalan Kerinchi, 59200
                Bangsar South, Kuala Lumpur.
              </div>
            </div>
          </div>
        </div>

        <div className="app-footer-bottom">
          <p className="app-footer-disclaimer Ft-12s-18l">
            {/* Disclaimer: TorumPay (Torum International Sdn Bhd 202201042743
            [1488440-AA]) is a fully regulated exchange licensed by the
            Securities Commission of Malaysia, with trading of digital assets
            using MYR enabled by our Digital Asset Exchange (DAX) license. */}
          </p>

          <p className="website-copyright Ft-12s-18l">
            © 2022 - {new Date().getFullYear()} Torum International Sdn. Bhd.
            All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AppFooter;
